import styled from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontBold, defaultSize } from "@fdr/static-ui/Typography";

export const Container = styled.section`
  background: ${buildColor("white", "100")};
  width: 100%;
  position: relative;
`;

export const LinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: ${buildColor("blue", "D1")};
  font-family: ${fontBold};
  font-weight: 700;
  font-size: ${defaultSize};
  line-height: 125%;
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${buildColor("white", "100")};
  border: 1px solid ${buildColor("grey", "L2")};
  border-radius: 50%;
  height: 48px;
  width: 48px;
  margin: 0 0 13px;

  &:hover {
    background-color: ${buildColor("navy", "100")};
  }
`;

export const LastElementContainer = styled.div<{ isFirstElement: boolean }>`
  margin-right: calc(100% - 280px);
  max-width: 280px;
  padding-left: ${({ isFirstElement }) => (isFirstElement ? "12px" : "8px")};
  height: auto;
  min-height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LastElement = styled.div`
  background: ${buildColor("white", "100")};
  min-height: 152px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const NoVideosContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 0 16px 12px;
  justify-content: space-between;
`;

export const VideoCardOutterContainer = styled.div`
  width: 280px;
  height: 250px;
  margin: 0 0 0 8px;
  border-radius: 4px;

  &:first-of-type {
    margin-left: 16px;
  }

  &:last-of-type {
    margin-right: 16px;
  }
`;
